import { Log } from "@/interfaces/Log.ts";
import { PaginatedResponse } from "@/interfaces/paginatedResponse.ts";
import axios from "@/lib/axios.ts";
import { useLogsStore } from "@/stores/Log.ts";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { storeToRefs } from "pinia";
import { watch } from "vue";

interface Params {
  id: number | string;
  page?: string | number;
}

interface Props {
  immediate?: boolean;
  params: Params;
}

const getRoleLog = async (params: Params): Promise<PaginatedResponse<Log>> => {
  const { data } = await axios.get<PaginatedResponse<Log>>(
    `/api/roles/${params.id}/logs?page=${params.page}`,
  );
  return data;
};

const useRoleLog = ({ immediate = true, params }: Props) => {
  const { setLog, setPage, setPagination } = useLogsStore();
  const { logs, page, pagination } = storeToRefs(useLogsStore());
  console.log(params);

  const { data, isLoading, refetch } = useQuery(
    ["roleLog", params],
    () =>
      getRoleLog({
        page: page.value,
        id: params.id,
      }),
    {
      enabled: immediate,
    },
  );

  watch(
    data,
    (value) => {
      if (value) {
        setLog(value.data);
        setPagination(_.omit(value, "data"));
      }
    },
    {
      immediate,
    },
  );

  return {
    logs,
    page,
    pagination,
    refetch,

    isLoading,
    setPage,
  };
};

export default useRoleLog;
